import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EmployeePlanAccountSchema = withDefaults({
  type: 'employee-plan-account',
  fields: [
    {
      kind: 'attribute',
      name: 'goodStanding',
    },
    {
      kind: 'attribute',
      name: 'goodStandingReason',
    },
    {
      kind: 'attribute',
      name: 'goodStandingDeterminedAt',
    },
    {
      kind: 'attribute',
      name: 'auditRequiredBy',
    },
    {
      kind: 'attribute',
      name: 'auditPastDue',
    },
    {
      kind: 'attribute',
      name: 'contributionPeriodEnd',
    },
    {
      kind: 'attribute',
      name: 'nextAuditStartsOn',
    },
    {
      // Requires include=good-standing-source-document.observable-asset; the document has no inverse reference.
      kind: 'belongsTo',
      name: 'goodStandingSourceDocument',
      type: 'observable-document',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'attribute',
      name: 'nameMatchConfirmation',
    },
    {
      kind: 'attribute',
      name: 'contributionOrder',
    },
    {
      kind: 'attribute',
      name: 'lockVersion',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'account',
      type: 'account',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default EmployeePlanAccountSchema;
